import * as tslib_1 from "tslib";
var HeaderState_1;
import { State, Action, Store, Selector } from '@ngxs/store';
import { filter, map, take, distinctUntilKeyChanged } from 'rxjs/operators';
import { clone } from 'lodash';
const category = 'Header';
export class ShowSelector {
    constructor(show) {
        this.show = show;
    }
}
ShowSelector.type = `[${category}] ShowSelector`;
export class ChangeLocation {
    constructor(loc) {
        this.loc = loc;
    }
}
ChangeLocation.type = `[${category}] ChangeLocation`;
let HeaderState = HeaderState_1 = class HeaderState {
    constructor(store) {
        this.store = store;
    }
    static selectorShown(state) {
        return state.selectorShown;
    }
    static currentLocation(state) {
        return state.location;
    }
    showSelector(ctx, action) {
        ctx.patchState({
            selectorShown: action.show,
        });
    }
    changeLocation(ctx, action) {
        localStorage.setItem('location', action.loc.id.toString());
        ctx.patchState({
            location: action.loc,
        });
    }
    getLocation() {
        return this.store.select(HeaderState_1.currentLocation).pipe(filter((loc) => !!loc), map((loc) => clone(loc)), take(1));
    }
    onChangeLocation() {
        return this.store.select(HeaderState_1.currentLocation).pipe(filter((loc) => !!loc), distinctUntilKeyChanged('id'), map((loc) => clone(loc)));
    }
};
tslib_1.__decorate([
    Action(ShowSelector),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, ShowSelector]),
    tslib_1.__metadata("design:returntype", void 0)
], HeaderState.prototype, "showSelector", null);
tslib_1.__decorate([
    Action(ChangeLocation),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, ChangeLocation]),
    tslib_1.__metadata("design:returntype", void 0)
], HeaderState.prototype, "changeLocation", null);
tslib_1.__decorate([
    Selector([HeaderState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], HeaderState, "selectorShown", null);
tslib_1.__decorate([
    Selector([HeaderState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], HeaderState, "currentLocation", null);
HeaderState = HeaderState_1 = tslib_1.__decorate([
    State({
        name: 'header',
        defaults: {
            selectorShown: false,
            location: null,
        },
    }),
    tslib_1.__metadata("design:paramtypes", [Store])
], HeaderState);
export { HeaderState };
